import { MappingTipiEntitaPratica as mapPrat } from '../../common/configuration/mapping-tipi-entita-pratica';
import { FrontEndMapping as mapFe } from './front-end-mapping';

export class UrlSettingsCore {
  public static readonly URL_VISUALIZZA_WELCOME_BOARD: string = 'welcome-board';
  public static readonly URL_VISUALIZZA_DASHBOARD: string = 'dashboard';
  public static readonly URL_CHANGE_PWD: string = 'changePwd';
  public static readonly URL_PROFILO_UTENTE: string = 'profiloUtente';
  public static readonly URL_SSO: string = 'SSO';
  public static readonly URL_AUTH_OUTLOOK: string = 'access-token';
  public static readonly URL_REFRESH_OUTLOOK: string = 'refresh-token';
  public static readonly URL_FORBIDDEN: string = 'forbidden';
  public static readonly URL_LOGIN: string = 'login';
  public static readonly URL_LOGOUT: string = 'logout';
  public static readonly URL_RICERCA: string = 'ricerca';
  //LEM
  public static readonly URL_GESTIONE_SOCIETA: string = 'gestionesocieta';
  public static readonly URL_RUBRICA_LEM: string = 'rubrica';
  public static readonly URL_ORGANI_LEM: string = 'organi';
  public static readonly URL_DIPARTIMENTI_LEM: string = 'dipartimenti';
  // CANCELLERIA TELEMATICA
  public static readonly URL_CANCELLERIA_TELEMATICA: string = 'cancelleria-telematica';
  public static readonly URL_CONSULTAZIONE_ANONIMA: string = 'consultazione-anonima';
  public static readonly URL_CONSULTAZIONE: string = 'consultazione';
  public static readonly URL_GESTIONE_DELEGHE_PDA: string = 'gestione-deleghe';
  public static readonly URL_GESTIONE_PAGAMENTI_PDA: string = "gestione-pagamenti";

  public static readonly URL_AMMINISTRAZIONE: string = 'amministrazione';
  public static readonly URL_GESTIONE_DOCUMENTI: string = 'gestione-documenti';
  public static readonly URL_UTILITY: string = 'utility';
  public static readonly URL_GESTIONE_CDA: string = 'cda';
  public static readonly URL_PROFILO_UTENTI: string = 'profilo-utenti';
  public static readonly URL_TEMPLATE_PROFILI_UTENTE: string =
    'template-profili-utente';
  public static readonly URL_REPORT: string = 'report';
  public static readonly URL_ERROR_PAGE: string = 'error_page';
  public static readonly URL_EML_FILE_PREVIEW: string = 'eml_file_preview';
  public static readonly URL_ZIP_FILE_PREVIEW: string = 'zip_file_preview';
  public static readonly URL_PDF_FILE_PREVIEW: string = 'pdf_file_preview';
  public static readonly URL_EML_FILE_PREVIEW_REF: string = 'eml_file_preview_ref';
  public static readonly URL_ZIP_FILE_PREVIEW_REF: string = 'zip_file_preview_ref';
  public static readonly URL_PDF_FILE_PREVIEW_REF: string = 'pdf_file_preview_ref';
  public static readonly URL_MODULO_PRATICA_CREATE: string =
    'inserimento/pratica';

  // NOTIFICHE
  public static readonly URL_PROSSIMI_ADEMPIMENTI: string =
    'prossimi-adempimenti';
  public static readonly URL_ADEMPIMENTI_INEVASI: string =
    'adempimenti-inevasi';
  public static readonly URL_NOTIFICHE_UTENTE: string = 'notifiche-utente';
  public static readonly URL_ATTIVITA_COMPLETARE: string =
    'attivita-completare';
  // FASCICOLO
  public static readonly URL_CREAZIONE_FASCICOLO: string =
    'creazione/fascicolo';

  // LAVORO
  public static readonly NOME_PRATICA_FRONT_END_LAVORO =
    mapFe.tipiPratica[mapPrat.PRATICA_LAVORO];
  public static readonly URL_MODULO_PRATICA_LAVORO: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_LAVORO;
  public static readonly URL_MODULO_PRATICA_LAVORO_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_LAVORO;
  public static readonly URL_VIEW_FASCICOLO_LAVORO: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_LAVORO;
  public static readonly URL_CREAZIONE_FASCICOLO_LAVORO: string =
    'creazione/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_LAVORO;
  public static readonly URL_INSERIMENTO_FASCICOLO_LAVORO: string =
    'inserimento/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_LAVORO;

  // CIVILE
  public static readonly NOME_PRATICA_FRONT_END_CIVILE =
    mapFe.tipiPratica[mapPrat.PRATICA_CIVILE];
  public static readonly URL_MODULO_PRATICA_CIVILE: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_CIVILE;
  public static readonly URL_MODULO_PRATICA_CIVILE_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_CIVILE;
  public static readonly URL_VIEW_FASCICOLO_CIVILE: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_CIVILE;
  public static readonly URL_CREAZIONE_FASCICOLO_CIVILE: string =
    'creazione/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_CIVILE;
  public static readonly URL_INSERIMENTO_FASCICOLO_CIVILE: string =
    'inserimento/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_CIVILE;

  // TRIBUTARIO
  public static readonly NOME_PRATICA_FRONT_END_TRIBUTARIO =
    mapFe.tipiPratica[mapPrat.PRATICA_TRIBUTARIO];
  public static readonly URL_MODULO_PRATICA_TRIBUTARIO: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_TRIBUTARIO;
  public static readonly URL_MODULO_PRATICA_TRIBUTARIO_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_TRIBUTARIO;
  public static readonly URL_VIEW_FASCICOLO_TRIBUTARIO: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_TRIBUTARIO;
  public static readonly URL_CREAZIONE_FASCICOLO_TRIBUTARIO: string =
    'creazione/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_TRIBUTARIO;
  public static readonly URL_INSERIMENTO_FASCICOLO_TRIBUTARIO: string =
    'inserimento/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_TRIBUTARIO;

  // PENALE
  public static readonly NOME_PRATICA_FRONT_END_PENALE =
    mapFe.tipiPratica[mapPrat.PRATICA_PENALE];
  public static readonly URL_MODULO_PRATICA_PENALE: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PENALE;
  public static readonly URL_MODULO_PRATICA_PENALE_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_PENALE;
  public static readonly URL_VIEW_FASCICOLO_PENALE: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PENALE;
  public static readonly URL_CREAZIONE_FASCICOLO_PENALE: string =
    'creazione/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PENALE;
  public static readonly URL_INSERIMENTO_FASCICOLO_PENALE: string =
    'inserimento/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PENALE;

  // AMMINISTRATIVA
  public static readonly NOME_PRATICA_FRONT_END_AMMINISTRATIVA =
    mapFe.tipiPratica[mapPrat.PRATICA_AMMINISTRATIVA];
  public static readonly URL_MODULO_PRATICA_AMMINISTRATIVA: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_AMMINISTRATIVA;
  public static readonly URL_MODULO_PRATICA_AMMINISTRATIVA_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_AMMINISTRATIVA;
  public static readonly URL_VIEW_FASCICOLO_AMMINISTRATIVA: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_AMMINISTRATIVA;
  public static readonly URL_CREAZIONE_FASCICOLO_AMMINISTRATIVA: string =
    'creazione/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_AMMINISTRATIVA;
  public static readonly URL_INSERIMENTO_FASCICOLO_AMMINISTRATIVA: string =
    'inserimento/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_AMMINISTRATIVA;

  // PARERISTICA
  public static readonly NOME_PRATICA_FRONT_END_PARERISTICA =
    mapFe.tipiPratica[mapPrat.PRATICA_PARERISTICA];
  public static readonly URL_MODULO_PRATICA_PARERISTICA: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PARERISTICA;
  public static readonly URL_MODULO_PRATICA_PARERISTICA_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_PARERISTICA;
  public static readonly URL_VIEW_FASCICOLO_PARERISTICA: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PARERISTICA;
  public static readonly URL_CREAZIONE_FASCICOLO_PARERISTICA: string =
    'creazione/fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_PARERISTICA;
  public static readonly URL_INSERIMENTO_FASCICOLO_PARERISTICA: string =
    'inserimento/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_PARERISTICA;

  // AUTORITA INDIPENDENTE
  public static readonly NOME_PRATICA_FRONT_END_AUTORITA_INDIPENDENTE =
    mapFe.tipiPratica[mapPrat.PRATICA_AUTORITA_INDIPENDENTE];
  public static readonly URL_MODULO_PRATICA_AUTORITA_INDIPENDENTE: string =
    'pratica/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_AUTORITA_INDIPENDENTE;
  public static readonly URL_MODULO_PRATICA_AUTORITA_INDIPENDENTE_CREATE: string =
    'inserimento/' + UrlSettingsCore.URL_MODULO_PRATICA_AUTORITA_INDIPENDENTE;
  public static readonly URL_VIEW_FASCICOLO_AUTORITA_INDIPENDENTE: string =
    'fascicolo/' + UrlSettingsCore.NOME_PRATICA_FRONT_END_AUTORITA_INDIPENDENTE;
  public static readonly URL_CREAZIONE_FASCICOLO_AUTORITA_INDIPENDENTE: string =
    'creazione/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_AUTORITA_INDIPENDENTE;
  public static readonly URL_INSERIMENTO_FASCICOLO_AUTORITA_INDIPENDENTE: string =
    'inserimento/fascicolo/' +
    UrlSettingsCore.NOME_PRATICA_FRONT_END_AUTORITA_INDIPENDENTE;

  // FASCICOLO PARERISTICA GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PARERISTICA: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_PARERISTICA + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PARERISTICA_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_PARERISTICA + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PARERISTICA_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_PARERISTICA +
    '/:genericFascicolo';

  // FASCICOLO LAVORO GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_LAVORO: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_LAVORO + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_LAVORO_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_LAVORO + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_LAVORO_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_LAVORO + '/:genericFascicolo';

  // FASCICOLO AMIANTO LAVORO
  // public static readonly NOME_FASCICOLO_FRONT_END_AMIANTO_LAVORO = mapFe.tipiFascicolo[mapFasc.FASCICOLO_AMIANTO];

  // FASCICOLO AMIANTO GIUDIZIALE LAVORO
  // public static readonly NOME_FASCICOLO_FRONT_END_AMIANTO_GIUDIZIALE_LAVORO = mapFe.tipiFascicolo[mapFasc.FASCICOLO_AMIANTO_GIUDIZIALE];

  // FASCICOLO CIVILE GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_CIVILE: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_CIVILE + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_CIVILE_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_CIVILE + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_CIVILE_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_CIVILE + '/:genericFascicolo';

  // FASCICOLO AMMINISTRATIVA GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_AMMINISTRATIVA + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_AMMINISTRATIVA +
    '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_AMMINISTRATIVA +
    '/:genericFascicolo';

  // FASCICOLO TRIBUTARIO GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_TRIBUTARIO + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_TRIBUTARIO + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_TRIBUTARIO + '/:genericFascicolo';

  // FASCICOLO AUTORITA_INDIPENDENTE GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_AUTORITA_INDIPENDENTE +
    '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_AUTORITA_INDIPENDENTE +
    '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_AUTORITA_INDIPENDENTE +
    '/:genericFascicolo';

  // FASCICOLO PENALE GENERIC
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PENALE: string =
    UrlSettingsCore.URL_VIEW_FASCICOLO_PENALE + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PENALE_CREATE: string =
    UrlSettingsCore.URL_CREAZIONE_FASCICOLO_PENALE + '/:genericFascicolo';
  public static readonly URL_MODULO_FASCICOLO_GENERIC_PENALE_INS: string =
    UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_PENALE + '/:genericFascicolo';

  ///fine fascicoli tributario///

  public static readonly URL_VISUALIZZA_SEZIONE_COPERTINA: string = 'copertina';
  public static readonly URL_VISUALIZZA_SEZIONE_DATI_GENERALI: string =
    'dati_generali';
  public static readonly URL_VISUALIZZA_SEZIONE_CONTROPARTI: string =
    'controparti';
  public static readonly URL_VISUALIZZA_SEZIONE_PATOLOGIE: string = 'patologie';
  public static readonly URL_VISUALIZZA_SEZIONE_SCHEDE_RECUPERO: string =
    'schede_recupero';
  public static readonly URL_VISUALIZZA_SEZIONE_SCHEDE_ESECUZIONE: string =
    'schede_esecuzione';
  public static readonly URL_VISUALIZZA_SEZIONE_LEGALI: string = 'legali';
  public static readonly URL_VISUALIZZA_SEZIONE_ALTREPARTI: string =
    'altre_parti';
  public static readonly URL_VISUALIZZA_SEZIONE_SEZIONE_ECONOMICA: string =
    'sezione_economica';
  public static readonly URL_VISUALIZZA_SEZIONE_SCADENZARIO: string =
    'scadenzario';
  public static readonly URL_VISUALIZZA_SEZIONE_ATTI: string = 'atti';
  public static readonly URL_VISUALIZZA_SEZIONE_ESITI: string = 'esiti';
  public static readonly URL_VISUALIZZA_SEZIONE_DOCUMENTAZIONE_ALLEGATA: string =
    'documentazione_allegata';
  public static readonly URL_VISUALIZZA_SEZIONE_PAGAMENTI: string = 'pagamenti';
  public static readonly URL_VISUALIZZA_SEZIONE_INCASSI: string = 'incassi';
  public static readonly URL_VISUALIZZA_SEZIONE_PARCELLE_GIUDIZIALI: string =
    'parcelle_giudiziali';
  public static readonly URL_VISUALIZZA_SEZIONE_PARCELLE_STRAGIUDIZIALI: string =
    'parcelle'; // 'parcelle_stragiudiziali';
  public static readonly URL_VISUALIZZA_SEZIONE_FATTURE: string = 'fatture';
  public static readonly URL_VISUALIZZA_SEZIONE_ASSEGNATARI: string =
    'assegnatari';
  public static readonly URL_VISUALIZZA_SEZIONE_BENI_MOBILI: string =
    'beni_pignorati_mobili';
  public static readonly URL_VISUALIZZA_SEZIONE_BENI_IMMOBILI: string =
    'beni_pignorati_immobili';
  public static readonly URL_VISUALIZZA_SEZIONE_DATI_PIGNORAMENTO: string =
    'dati_pignoramento';
  public static readonly URL_VISUALIZZA_SEZIONE_TITOLI_PROVE_SCRITTE: string =
    'titoli_prove_scritte';
  public static readonly URL_VISUALIZZA_SEZIONE_LETTERE_DIFFIDA: string =
    'lettere_diffida';
  public static readonly URL_VISUALIZZA_SEZIONE_CENSIMENTO_DOCUMENTI: string = 'censimento_documenti';
  public static readonly URL_VISUALIZZA_SEZIONE_BANCHE_DATI: string = 'banchedati';
  public static readonly URL_VISUALIZZA_SEZIONE_EVENTI_CANCELLERIA: string = 'eventicancelleria';
  public static readonly URL_VISUALIZZA_SEZIONE_REATI: string ='reati';


  // Pannello Amministrazione
  public static readonly URL_AMMINISTRAZIONE_GESTIONE: string = 'gestione';
  public static readonly URL_GESTIONE_TIPOLOGICA_BASE: string = 'tipologiche';
  public static readonly URL_ASSOCIAZIONE_MATERIA_OGGETTO_ARGOMENTO: string =
    'associazione_materia_oggetto_argomento';
  public static readonly URL_ASSOCIATIVA_TIPOLOGICHE_ESITO: string =
    'associazione_tipologiche_esito';
  public static readonly URL_ASSOCIATIVA_TIPOLOGICHE_AUTORITA_GIUDIZIARIE: string =
    'associazione_tipologiche_autorita_giudiziarie';
  public static readonly URL_ASSOCIATIVA_TIPO_FASCICOLO_GRADO_AUTORITA_GIUDIZIARIE: string =
    'associazione_fascicolo_grado_autorita_giudiziarie';
  public static readonly URL_ASSOCIAZIONE_METADATA_TIPO_PRATICA: string =
    'associazione_metadata_tipo_pratica';
  public static readonly URL_ASSOCIAZIONE_METADATA_TIPO_FASCICOLO: string =
    'associazione_metadata_tipo_fascicolo';
  public static readonly URL_ASSOCIATIVA_GRUPPI: string = 'associazione_gruppi';
  public static readonly URL_GESTIONE_ANAGRAFICA_BASE: string = 'anagrafiche';
  public static readonly URL_ANAGRAFICA_PARTI: string = 'anagrafica_parti';
  public static readonly URL_ANAGRAFICA_LEGALI: string = 'anagrafica_legali';
  public static readonly URL_ANAGRAFICA_SOGGETTO: string = 'soggetto';
  public static readonly URL_ANAGRAFICA_AUTORITA_INDIPENDENTE: string =
    'autoritaindipendente';
  public static readonly URL_ANAGRAFICA_AUTORITA_GIUDIZIARIA: string =
    'autoritagiudiziaria';
  public static readonly URL_ANAGRAFICA_SEDE_TERRITORIALE: string =
    'sedeterritoriale';
  public static readonly URL_ANAGRAFICA_DIREZIONE_TERR_LAVORO: string =
    'direzioneterritorialelavoro';
  public static readonly URL_ANAGRAFICA_ORGANO_ISPETTIVO: string =
    'organoispettivo';
  public static readonly URL_ANAGRAFICA_IMPIANTI: string = 'impianti';
  public static readonly URL_ANAGRAFICA_GRUPPO_TERRITORIALE: string =
    'gruppoterritoriale';
  public static readonly URL_ANAGRAFICA_GRUPPO_VISIBILITA: string =
    'gruppovisibilita';
  public static readonly URL_GESTIONE_TABELLA_BASE: string =
    'gestione_tabella_base';
  public static readonly URL_TABELLA_VISIBILITA_CLASSIFICAZIONE: string =
    'visibilita_classificazione';
  public static readonly URL_FORMULARIO: string = 'formulario';
  public static readonly URL_SCADENZARIO: string = 'scadenzario';
  public static readonly URL_TEMPLATE: string = 'template';
  public static readonly URL_TARIFFE: string = 'tariffe';
  public static readonly URL_METADATI: string = 'metadati';
  public static readonly URL_NOTIFICHE: string = 'notifiche';
  public static readonly URL_CONSERVAZIONE: string = 'conservazione';

  // URL SEZIONI WIZARD - INSERIMENTO
  public static readonly URL_INSERIMENTO_DATI_GENERALI_PRATICA: string =
    'dati_generali_pratica';
  public static readonly URL_INSERIMENTO_DATI_GENERALI_FASCICOLO: string =
    'dati_generali_fascicolo';
  public static readonly URL_INSERIMENTO_CONTROPARTI_FASCICOLO =
    'controparti_fascicolo';
  public static readonly URL_INSERIMENTO_LEGALI_FASCICOLO = 'legali_fascicolo';
  public static readonly URL_INSERIMENTO_ALTRE_PARTI_FASCICOLO =
    'altre_parti_fascicolo';
  public static readonly URL_INSERIMENTO_SEZIONE_ECONOMICA_FASCICOLO =
    'sezione_economica_fascicolo';
  public static readonly URL_INSERIMENTO_ATTI_FASCICOLO = 'atti_fascicolo';
  public static readonly URL_INSERIMENTO_SCADENZARIO_FASCICOLO =
    'scadenzario_fascicolo';
  public static readonly URL_INSERIMENTO_DOCUMENTAZIONE_ALLEGATA_FASCICOLO =
    'documentazione_allegata_fascicolo';
  public static readonly URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO =
    'assegnazione_per_smistamento';
  public static readonly URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA =
    'assegnazione_per_competenza';

  // UTILITY
  public static readonly URL_UTILITY_GESTIONE: string = 'gestione';
  public static readonly URL_AGGIORNAMENTO_MASSIVO_CLASSIFICAZIONE =
    'aggiornamento_massivo_classificazione';
  public static readonly URL_ESTRAZIONE_DATI = 'estrazione_dati';
  public static readonly URL_STAMPA_SCHEDE = 'stampa_schede';

  // SCHEDA ANALITICA
  public static readonly URL_SCHEDA_ANALITICA = 'scheda_analitica';
  // SCHEDA SINTETICA
  public static readonly URL_SCHEDA_SINTETICA = 'scheda_sintetica';

}
